export const RETURN_CANCEL_STATUS_TAB_STORAGE_KEY = "return_cancel_status_tab";
export const RETURN_CANCEL_LAST_OPENED_STORAGE_KEY = "return_cancel_last_opened_id";
export const RETURN_CANCEL_LIST_STATE_STORAGE_KEY = "return_cancel_list_state";

export const saveReturnCancelStatusTab = (tab) => {
  if (tab === "Returned" || tab === "Cancelled") {
    sessionStorage.setItem(RETURN_CANCEL_STATUS_TAB_STORAGE_KEY, tab);
  }
};

export const getSavedReturnCancelStatusTab = () => {
  const savedTab = sessionStorage.getItem(RETURN_CANCEL_STATUS_TAB_STORAGE_KEY);
  return savedTab === "Returned" || savedTab === "Cancelled" ? savedTab : null;
};

export const clearSavedReturnCancelStatusTab = () => {
  sessionStorage.removeItem(RETURN_CANCEL_STATUS_TAB_STORAGE_KEY);
};

export const consumeSavedReturnCancelStatusTab = () => {
  const savedTab = getSavedReturnCancelStatusTab();
  if (!savedTab) return null;
  clearSavedReturnCancelStatusTab();
  return savedTab;
};

export const saveReturnCancelListState = (state = {}) => {
  try {
    sessionStorage.setItem(RETURN_CANCEL_LIST_STATE_STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.error("Failed to save Return/Cancel list state:", error);
  }
};

export const consumeSavedReturnCancelListState = () => {
  try {
    const raw = sessionStorage.getItem(RETURN_CANCEL_LIST_STATE_STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(RETURN_CANCEL_LIST_STATE_STORAGE_KEY);
    return JSON.parse(raw);
  } catch (error) {
    console.error("Failed to restore Return/Cancel list state:", error);
    sessionStorage.removeItem(RETURN_CANCEL_LIST_STATE_STORAGE_KEY);
    return null;
  }
};

export const rememberLastOpenedReturnCancelOrder = (orderOrId) => {
  const orderId =
    typeof orderOrId === "object" && orderOrId != null
      ? orderOrId.order_id || orderOrId.id
      : orderOrId;
  if (orderId == null || orderId === "") return;
  sessionStorage.setItem(RETURN_CANCEL_LAST_OPENED_STORAGE_KEY, String(orderId));
};

export const getLastOpenedReturnCancelOrderId = () =>
  sessionStorage.getItem(RETURN_CANCEL_LAST_OPENED_STORAGE_KEY);
